<template>
  <NuxtLinkLocale class="ai-widget" :to="authenticated ? localePath('/chat/ai') : localePath('/login')">
    <div class="ai-widget__content">
      <h2>{{ $t('AI_CHAT.CTA') }}</h2>
    </div>
  </NuxtLinkLocale>
</template>
<script lang="ts" setup>
import { useAuthStore } from '~/stores/authStore'

const localePath = useLocalePath()

const { authenticated } = storeToRefs(useAuthStore())
</script>
<style lang="scss">
.ai-widget {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 999;
  width: 500px;
  max-width: 70vw;
  aspect-ratio: 4.04;
  background: url('@/assets/img/common/ai_background.svg?skipsvgo') no-repeat;
  background-size: auto 100%;
  background-position: center bottom;
  transition: filter 0.2s ease;
  &:hover {
    transition: filter 0.2s ease;
    filter: drop-shadow(0 0 5px #b7cbff);
  }
  &__content {
    margin-top: 30px;
    padding-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}
@media (max-width: 1496px) {
  .ai-widget {
    width: 400px;
    &__content {
      font-size: var(--font-xsmall);
      margin-top: 0px;
      padding-top: 40px;
    }
  }
}
@media (max-width: 768px) {
  .ai-widget {
    &__content {
      margin-top: 20px;
      padding-top: 20px;
    }
  }
}
</style>
